import { Component, OnInit ,Input,Output,EventEmitter, ElementRef, ViewChild} from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { AccountService,InstoreService } from '@app/_services'; 
import { first } from 'rxjs/operators';
import { UntypedFormGroup,UntypedFormBuilder } from '@angular/forms';
import { ToastrService,IndividualConfig } from 'ngx-toastr';
import * as moment from 'moment';                                                  
import {Sort} from '@angular/material/sort';
import { HoardinglistComponent } from '@app/module/hoardinglist/hoardinglist/hoardinglist.component';
import { ConfirmDialogService } from '@app/module/confirm-dialog/confirm-dialog/confirm-dialog.service';  
import { DataService } from '@app/_services';

// import { MapsAPILoader, MouseEvent as AGMMouseEvent, AgmMap } from '@agm/core'  


@Component({
  selector: 'app-modifyhoarding',
  templateUrl: './modifyhoarding.component.html',
  styleUrls: ['./modifyhoarding.component.css']
})
export class ModifyhoardingComponent implements OnInit {
  // @ViewChild('agmMap') agmMap : AgmMap


  searchTerm:string="";
  @Input() startDateLabel: string;
  @Input() endDateLabel: string;

  @Input() startDateInput;
  @Input() endDateInput;
  @Output() StartEndDatesOutput = new EventEmitter();


  @Input() selected_Hoarding_Lists:any=[];
  filtered_Hoarding_Lists:any=[];


  form: UntypedFormGroup;
  options: IndividualConfig;
  message:string;
  private format = 'YYYY-MM-DD';

  latitude: number;
  longitude: number;
  zoom:number;
  address: string;
  minDate: any;

  isAllChecked:boolean;
  isShowBtn:boolean;
  constructor(private instoreService: InstoreService, private hoardingList :HoardinglistComponent,private confirmDialogService: ConfirmDialogService ,
    private formBuilder: UntypedFormBuilder,private modalService: NgbModal,private toastr: ToastrService, private accountService: AccountService,private dataService:DataService
    // private mapsAPILoader: MapsAPILoader
    ) {
    this.isAllChecked = false;
    this.isShowBtn = false;
    this.options = this.toastr.toastrConfig;
    this.options.timeOut = 1000;
   }
  page = 1;
  pageSize = 10;
  AssetsDataLists;
  CreativeDataLists;
  VendorDataLists;
  isLoading = false;

  isUpdate;
  selected_showroom_id;

  checked_HoardingLists=[];
  selectedAssetIds = [];
  selectedCreativeIds =[];
  selectedVendorIds =[];

  user_role_id: number=0;
  isDiscontinue:boolean = false;

  ngOnInit(): void {

    /* ----------  true----> Update     false -----> Modify ---------- */


    this.isUpdate = this.instoreService.getIsUpdateorModify();
    this.selected_Hoarding_Lists = JSON.parse(localStorage.getItem('lists')).slice();

    this.selected_showroom_id = this.instoreService.getShowroomID();

    this.reloadAssetsLists()
    this.reloadCreativeLists()
    this.reloadVendorLists()

    this.form = this.formBuilder.group({
      hoarding_ids:'',
      address: [''],
      particulars: [''], //m
      region_id: [''], //m
      showroom_id: [''], //m
      floor_id: [''], //m
      asset_type_id: [''], //m
      creative_id: [''], //m
      vendor_id: [''], //m
      name : [''], //m
      size_w: [''], //m
      // lat: [''], //m
      // lang: [''], //m
      size_h: [''], //m
      square_feet:[''],
      install_date: [''], //m
      expiry_date: [''], //m
      image: [''],
      cost:['']    });

      // this.mapsAPILoader.load().then(() => {
      //   this.setCurrentLocation();
      //   console.log("After Log");
      // });

      var userdata = localStorage.getItem('userInformation');
      var parsedUserData = JSON.parse(userdata);
      if(parsedUserData) {
        this.user_role_id = parsedUserData.role_id;
        if(this.user_role_id==1 || this.user_role_id ==2){
          this.isDiscontinue = true;
        }else{
          this.isDiscontinue = false
        }
      }

      
    this.dataService.getAssetDataLists().subscribe(assetIDs => {
      this.selectedAssetIds = assetIDs;
      this.filterTable();
    })
    this.dataService.getCreativeDataLists().subscribe(creativeIDs => {
      this.selectedCreativeIds = creativeIDs;
      this.filterTable();
    })
    this.dataService.getVendorDataLists().subscribe(vendorIds => {
      this.selectedVendorIds = vendorIds;
      this.filterTable();
    })
    this.dataService.getSearchText().subscribe(searchText => {
      this.searchTerm = searchText;
      console.log(this.searchTerm)
    })
  }

  get f() { return this.form.controls; }

      // Get Current Location Coordinates
      private setCurrentLocation() {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            this.zoom = 10;
          });
        }
      }
  
      // markerDragEnd($event: AGMMouseEvent) {
      //   console.log($event);
      //   this.latitude = $event.coords.lat;
      //   this.longitude = $event.coords.lng;
      //   //this.getAddress(this.latitude, this.longitude);
      //   this.form.get("lat").setValue(this.latitude); //Working
      //   this.form.get("lang").setValue(this.longitude); //Working
      // }

  CheckAllOptions(){
      this.checkisAllSelected();
      for (let i = 0; i < this.filtered_Hoarding_Lists.length; i++) {
          if(this.isAllChecked){
              this.filtered_Hoarding_Lists[i].isUpdateModify = false;
          }else{
              this.filtered_Hoarding_Lists[i].isUpdateModify = true;
          }
      }
      this.checkisAllSelected();
      this.isShowButton();
  }


  settoUdpateModify(id){
    for (let i = 0; i < this.filtered_Hoarding_Lists.length; i++) {
      if(this.filtered_Hoarding_Lists[i].id===id){
        if(this.filtered_Hoarding_Lists[i].isUpdateModify){
          this.filtered_Hoarding_Lists[i].isUpdateModify = false;
        }else{
          this.filtered_Hoarding_Lists[i].isUpdateModify = true;
        }
      }
    }
    this.checkisAllSelected();
    this.isShowButton();
  }
  public splitNumber(value: number):string {
    if(value!=null){
      if(value == 0){
        return 0+"";
      }
      return Math.round(value * 100) / 100+"'";
      // var str = value.toString();
      // var numarray = str.split('.');
      // var a = new Array();
      // a = numarray;
      // if(a[1] ==0 || a[1] == null|| a[1] == ''|| a[1] ==undefined){
      //   return a[0]+"'";
      // }else{
      //   a[1] = a[1].slice(0, 2);
      //   return a[0] +"' "+ a[1]+"\"";
      // }
    }
  }
  onHoardingSubmit(){
    this.form.controls.hoarding_ids.setValue(this.checked_HoardingLists.toString());
    if(this.f.install_date.value !=""){
      this.form.get("install_date").setValue(moment(this.f.install_date.value).format(this.format)); //Working
    }
    if(this.f.expiry_date.value !=""){
      this.form.get("expiry_date").setValue(moment(this.f.expiry_date.value).format(this.format)); //Working
    }

    if(this.f.install_date.value != "" && this.f.expiry_date.value === ""){
      this.toastr.warning("Please select Expiry Date", "info"); 
      return;
    }
    if(this.f.install_date.value === "" && this.f.expiry_date.value  != ""){
      this.toastr.warning("Please select Installation Date", "info");  
      return;
    }
    
    const formDataNew = new FormData();   
    formDataNew.append('hoarding_ids', this.form.value.hoarding_ids);
    formDataNew.append('particulars',  this.form.value.particulars);
    formDataNew.append('region_id',  this.form.value.region_id);
    formDataNew.append('showroom_id',  this.selected_showroom_id);
    formDataNew.append('asset_type_id',  this.form.value.asset_type_id);
    formDataNew.append('creative_id',  this.form.value.creative_id);
    formDataNew.append('vendor_id', this.form.value.vendor_id);
    formDataNew.append('address', this.form.value.address);
    // formDataNew.append('lat',  this.form.value.lat);
    // formDataNew.append('lang',  this.form.value.lang);
    formDataNew.append('cost',  this.form.value.cost);
    formDataNew.append('name',  this.form.value.name);
    formDataNew.append('address',  this.form.value.address);
    formDataNew.append('size_w',  this.form.value.size_w);
    formDataNew.append('size_h', this.form.value.size_h);
    formDataNew.append('square_feet',  this.form.value.square_feet);
    formDataNew.append('install_date',  this.form.value.install_date);
    formDataNew.append('expiry_date', this.form.value.expiry_date);
    formDataNew.append('image', this.form.get('image').value);


    if(this.isUpdate){
      this.instoreService.hoardingBulkUpdate(formDataNew)
      .pipe(first())
        .subscribe(
        (response) => {
          this.isLoading = false;
          //console.log("=response=="+JSON.stringify(response));
          this.toastr.warning("Record has been modified successfully", "Success"); 
          this.modalService.dismissAll();
          this.hoardingList.viewModule();
         
        },
      (error) => {     
        this.isLoading = false;                               
      }
      );
      
    }else{
      this.instoreService.hoardingBulkModify(formDataNew)
      .pipe(first())
        .subscribe(
        (response) => {
          this.isLoading = false;
          //console.log("=response=="+JSON.stringify(response));
          this.toastr.warning("Record has been modified successfully", "Success"); 
          this.modalService.dismissAll();
          this.hoardingList.viewModule();
          //this.hoardingList.getHoardingInformation();
        },
      (error) => {     
        this.isLoading = false;                               
      }
      );
    }
  
  }
  omit_special_char(event) {   
    var k;  
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }

  
  closeResult :string
  open(content) {

    this.checked_HoardingLists=[];
    for (let i = 0; i < this.filtered_Hoarding_Lists.length; i++) {
        if(this.filtered_Hoarding_Lists[i].isUpdateModify){
          this.checked_HoardingLists.push(this.filtered_Hoarding_Lists[i].id);
        }
    }
   

    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'lg'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  onWidthChange(){
    if(this.form.controls.size_w.value !=null ||this.form.controls.size_w.value !=''){
      if(this.form.controls.size_h.value !=null ||this.form.controls.size_h.value !=''){
        var squarefeet = this.form.controls.size_h.value *this.form.controls.size_h.value;
        this.form.controls.square_feet.setValue(squarefeet);
      }
    }
  }
  onHeightChange(){
    if(this.form.controls.size_h.value !=null ||this.form.controls.size_h.value!=''){
      if(this.form.controls.size_w.value !=null ||this.form.controls.size_w.value!=''){
        var squarefeet = this.form.controls.size_h.value *this.form.controls.size_h.value;
        this.form.controls.square_feet.setValue(squarefeet);
      }
    }
  }

  sortData(sort: Sort) {
    const data = this.filtered_Hoarding_Lists.slice();
    if (!sort.active || sort.direction == '') {
      this.filtered_Hoarding_Lists = data;
      return;
    }
    
    this.filtered_Hoarding_Lists = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.accountService.compare(a.name, b.name, isAsc);
        case 'address': return this.accountService.compare(a.address, b.address, isAsc);
        case 'vendorName': return this.accountService.compare(a.vendorName, b.vendorName, isAsc);
        case 'assetTypeName': return this.accountService.compare(a.assetTypeName, b.assetTypeName, isAsc);
        case 'creativeName': return this.accountService.compare(a.creativeName, b.creativeName, isAsc);
        case 'cost': return this.accountService.compare(a.cost, b.cost, isAsc);
        case 'regionName': return this.accountService.compare(a.regionName, b.regionName, isAsc);
        case 'showroomName': return this.accountService.compare(a.showroomName, b.showroomName, isAsc);

      }
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  checkisAllSelected(){
      this.isAllChecked = this.filtered_Hoarding_Lists.every(function(item:any) {
        return item.isUpdateModify == true;
      })   
  }
  isShowButton(){
    var count_SelectedHoardings= [];
    for (let i = 0; i < this.filtered_Hoarding_Lists.length; i++) {
        if(this.filtered_Hoarding_Lists[i].isUpdateModify){
          count_SelectedHoardings.push(this.filtered_Hoarding_Lists[i]);
          // this.isShowBtn =true;
          // break;
        }else{
          // this.isShowBtn =false;
        }
    }
    if(count_SelectedHoardings.length>1){
      this.isShowBtn =true;
    }else{
      this.isShowBtn =false;
    }
   
  }
  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  
   reloadVendorLists(){
    this.accountService.getVendorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.VendorDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  imageSrc: string;

  onFileChange(event) {
    
    const max_size = 5242880;
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];


    const reader = new FileReader();
    const file:File = event.target.files[0];

    if (file.size > max_size) {
        alert("Image Size should not exceed more than 5 MB")
        return false;
    }
    
    
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        /*
        this.form.patchValue({
          image: reader.result
        });
        */
       this.form.get('image').setValue(event.target.files[0]);
       //console.log("onFileChange "+event.target.files[0]);
      };  
    }
  }
  discontinue(){


    this.checked_HoardingLists=[];
    for (let i = 0; i < this.filtered_Hoarding_Lists.length; i++) {
        if(this.filtered_Hoarding_Lists[i].isUpdateModify){
          this.checked_HoardingLists.push(this.filtered_Hoarding_Lists[i].id);
        }
    }
      this.confirmDialogService.confirmThis('Are you sure you want to discontinue ?', () =>  {
      this.isLoading = true;
      this.instoreService.bulkhoardingDiscontinue(this.checked_HoardingLists,1)
      .pipe(first())
        .subscribe(
        (response) => {
          //console.log(response)
          this.isLoading = false;
          this.toastr.warning("Record has been updated successfully", "Success");     
        },
      (error) => {     
        this.isLoading = false;                 
        this.toastr.warning("Sorry, something went wrong Please try again", "Warning");              
      }
      );
      }, () => {
        
      }); 

  }
  startDateClicked() {
    this.StartEndDatesOutput.emit(this.getDates());
  }

  endDateClicked() {
    if (this.form.controls['install_date'].value) {
      let eventStartTime = new Date(this.form.controls['install_date'].value);
      let eventEndTime = new Date(this.form.controls['expiry_date'].value);
      this.StartEndDatesOutput.emit(this.getDates());
    } else {
      //console.log('Please select the start date');
      this.form.controls['expiry_date'].setValue('');
    }
  }

  getDates() {
    let startEndDates = {
      'install_date': this.form.controls['install_date'].value,
      'expiry_date': this.form.controls['expiry_date'].value
    };
    return startEndDates;
  }

  
  filterTable() {
    // console.log("instore ids - - "+this.selectedAssetIds);
    // console.log("creative ids - - "+this.selectedCreativeIds);
    // console.log("vendor ids - - "+this.selectedVendorIds);
    this.filtered_Hoarding_Lists=[];
    if(this.selectedAssetIds.length>0  &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
      this.filtered_Hoarding_Lists = [
         ...this.selected_Hoarding_Lists.filter(x => this.selectedAssetIds.includes(x.asset_type_id))
    ];
  }else if(this.selectedAssetIds.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
    //console.log("creative ids - - "+this.selectedCreativeIds);
      this.filtered_Hoarding_Lists = [
          ...this.selected_Hoarding_Lists.filter(x => this.selectedCreativeIds.includes(x.creative_id))
    ];
  }else if(this.selectedAssetIds.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
      this.filtered_Hoarding_Lists = [
          ...this.selected_Hoarding_Lists.filter(x => this.selectedVendorIds.includes(x.vendor_id))
    ];
  }


 else if(this.selectedAssetIds.length>0  &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
  this.filtered_Hoarding_Lists = [
    ...this.selected_Hoarding_Lists.filter(x => this.selectedAssetIds.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id))
  ];
  }else if(this.selectedAssetIds.length>0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
    this.filtered_Hoarding_Lists = [
      ...this.selected_Hoarding_Lists.filter(x => this.selectedAssetIds.includes(x.asset_type_id) && this.selectedVendorIds.includes(x.vendor_id))
    ];
  }else if(this.selectedAssetIds.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length>0){
    this.filtered_Hoarding_Lists = [
      ...this.selected_Hoarding_Lists.filter(x => this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
    ];
  }



  else if(this.selectedAssetIds.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
      this.filtered_Hoarding_Lists = [...this.selected_Hoarding_Lists];
  }else{
      this.filtered_Hoarding_Lists = [
        ...this.selected_Hoarding_Lists.filter(x => this.selectedAssetIds.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id)&& this.selectedVendorIds.includes(x.vendor_id))
      ];
  }
  //console.log("---"+this.filtered_Hoarding_Lists.length)
  }
}


